import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import { fetchWrapper } from "_utils/fetch-wrapper";
import { dntReportNoAccess } from "container/marketer/Reports/doNotTrackReport/mockData";

const name = "dntreport";
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

export const dntReportActions = { ...slice.actions, ...extraActions };
export const dntReportReducer = slice.reducer;

// Initial state
function createInitialState() {
  return {
    dntReportData: [],
    error: null,
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_MARKETER_API_URL}/api/Marketer`;
  return {
    getDNTReportData: getDNTReportData(),
  };

  function getDNTReportData() {
    return createAsyncThunk(
      `${name}/getDNTReportData`,
      async (_, { rejectWithValue }) => {
        try {
          const response = await trackPromise(
            fetchWrapper.get(`${baseUrl}/report/do-not-transfer`)
          );

          // commented lines below are for testing failed scenario
          // const response = dntReportNoAccess;
          // if (!response.Succeeded) {
          //   throw new Error(response.Message);
          // }
          return response;
        } catch (error) {
          return rejectWithValue(error);
        }
      }
    );
  }
}

function createReducers() {
  return {
    clearDNTReportData: clearDNTReportData,
  };

  function clearDNTReportData(state) {
    state.dntReportData = [];
    state.error = null;
  }
}

function createExtraReducers() {
  return (builder) => {
    getDNTReport();
    function getDNTReport() {
      var { pending, fulfilled, rejected } = extraActions.getDNTReportData;
      builder
        .addCase(pending, (state) => {
          state.dntReportData = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          const data = action.payload;
          state.dntReportData = data.Data;
        })
        .addCase(rejected, (state, action) => {
          state.dntReportData = { error: action.error };
        });
    }
  };
}
